/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { ResponseWithErrorGeneric } from '../shared/response-with-error-generic';
import { LoadSharedDataResponseJson } from './load-shared-data-response-json';
import { LoadSharedDataResult } from '../results/load-shared-data-result.enum';
import { IResponseWithErrorGeneric } from '../shared/iresponse-with-error-generic.interface';
import { AdditionalTaxTypeDto } from '../models/additional-tax-type-dto';
import { MeasurementUnitDto } from '../models/measurement-unit-dto';
import { CustomsOfficeDto } from '../models/customs-office-dto';
import { CurrencyDto } from '../models/currency-dto';
import { GoodsLocationNoDto } from '../models/goods-location-no-dto';
import { TransportTypeDto } from '../models/transport-type-dto';
import { TransactionTypeDto } from '../models/transaction-type-dto';
import { DeliveryConditionDto } from '../models/delivery-condition-dto';
import { LoadingLocationDto } from '../models/loading-location-dto';
import { DeclarationDto } from '../models/declaration-dto';
import { DeclarationTypeDto } from '../models/declaration-type-dto';
import { RegionDto } from '../models/region-dto';
import { ProcedureDto } from '../models/procedure-dto';
import { ProcedureAddonDto } from '../models/procedure-addon-dto';
import { PreferenceDto } from '../models/preference-dto';
import { CustomsWarehouseDto } from '../models/customs-warehouse-dto';
import { CustomsWarehouseTypeDto } from '../models/customs-warehouse-type-dto';
import { ValueDeterminationDto } from '../models/value-determination-dto';
import { SummaryDeclarationDto } from '../models/summary-declaration-dto';
import { SummaryDeclarationSubtypeDto } from '../models/summary-declaration-subtype-dto';
import { SpecificInformationDto } from '../models/specific-information-dto';
import { AttachedDocumentTypeDto } from '../models/attached-document-type-dto';
import { DelegateDto } from '../models/delegate-dto';
import { MeasureDto } from '../models/measure-dto';
import { ExchangeRateDto } from '../models/exchange-rate-dto';
import { NoExpUnitDto } from '../models/no-exp-unit-dto';
import { AirFreightZoneDto } from '../models/air-freight-zone-dto';
import { AdditionalInformationDto } from '../models/additional-information-dto';
import { EarlierDocumentDto } from '../models/earlier-document-dto';
import { TransportDocumentDto } from '../models/transport-document-dto';
import { AdditionDeductionDto } from '../models/addition-deduction-dto';
import { AuthorisationDto } from '../models/authorisation-dto';

//<custom-head>
import { HttpResponse } from '@angular/common/http';
import { CustomsOffice } from 'cases/models';
import { orderBy } from 'lodash-es';
//</custom-head>

export class LoadSharedDataResponse extends ResponseWithErrorGeneric<LoadSharedDataResponseJson, LoadSharedDataResult> implements IResponseWithErrorGeneric<LoadSharedDataResult> {
  public additionalTaxTypes: AdditionalTaxTypeDto[];
  public measurementUnits: MeasurementUnitDto[];
  public customsOffices: CustomsOfficeDto[];
  public currencies: CurrencyDto[];
  public goodsLocations: GoodsLocationNoDto[];
  public transportTypeDetails: TransportTypeDto[];
  public transactionTypes: TransactionTypeDto[];
  public deliveryConditions: DeliveryConditionDto[];
  public loadingLocations: LoadingLocationDto[];
  public declarations: DeclarationDto[];
  public declarationTypes: DeclarationTypeDto[];
  public regions: RegionDto[];
  public procedures: ProcedureDto[];
  public procedureAddons: ProcedureAddonDto[];
  public preferences: PreferenceDto[];
  public warehouses: CustomsWarehouseDto[];
  public warehouseTypes: CustomsWarehouseTypeDto[];
  public valueDeterminations: ValueDeterminationDto[];
  public summaryDeclarations: SummaryDeclarationDto[];
  public summarySubtypes: SummaryDeclarationSubtypeDto[];
  public specificInformation: SpecificInformationDto[];
  public documentTypes: AttachedDocumentTypeDto[];
  public delegates: DelegateDto[];
  public measures: MeasureDto[];
  public exchangeRates: ExchangeRateDto[];
  public noExpUnits: NoExpUnitDto[];
  public airFreightZones: AirFreightZoneDto[];
  public additionalInformation: AdditionalInformationDto[];
  public earlierDocuments: EarlierDocumentDto[];
  public transportDocuments: TransportDocumentDto[];
  public additionDeductions: AdditionDeductionDto[];
  public authorisations: AuthorisationDto[];

  //<custom-body>
  constructor(response: HttpResponse<LoadSharedDataResponse>) {
    super(response, LoadSharedDataResult.Error);
    if (this.result !== LoadSharedDataResult.Success) {
      return;
    }

    this.additionalTaxTypes = this.body.additionalTaxTypes;
    this.measurementUnits = this.body.measurementUnits;
    this.customsOffices = orderBy(this.body.customsOffices.map(office => new CustomsOffice(office)), office => office.text);
    this.currencies = this.body.currencies;
    this.goodsLocations = this.body.goodsLocations;
    this.transportTypeDetails = this.body.transportTypeDetails;
    this.transactionTypes = this.body.transactionTypes;
    this.deliveryConditions = this.body.deliveryConditions;
    this.loadingLocations = this.body.loadingLocations;
    this.declarations = this.body.declarations;
    this.declarationTypes = this.body.declarationTypes;
    this.regions = this.body.regions;
    this.procedures = this.body.procedures;
    this.procedureAddons = this.body.procedureAddons;
    this.preferences = this.body.preferences;
    this.warehouses = this.body.warehouses;
    this.warehouseTypes = this.body.warehouseTypes;
    this.valueDeterminations = this.body.valueDeterminations;
    this.summaryDeclarations = this.body.summaryDeclarations;
    this.summarySubtypes = this.body.summarySubtypes;
    this.specificInformation = this.body.specificInformation;
    this.documentTypes = this.body.documentTypes;
    this.delegates = this.body.delegates;
    this.measures = this.body.measures;
    this.exchangeRates = this.body.exchangeRates;
    this.noExpUnits = this.body.noExpUnits.map(expUnit => new NoExpUnitDto(expUnit));
    this.airFreightZones = this.body.airFreightZones;
    this.additionalInformation = this.body.additionalInformation;
    this.earlierDocuments = this.body.earlierDocuments;
    this.transportDocuments = this.body.transportDocuments;
    this.additionDeductions = this.body.additionDeductions;
    this.authorisations = this.body.authorisations;
  }
  //</custom-body>
}
